<div *ngIf="edit" fxLayout="row" fxLayoutAlign="space-between center">
  <div fxFlex="100">
    <mat-form-field appearance="outline">
      <mat-label>Lugar, detalle de la ubicacion</mat-label>
      <input
        matInput
        type="text"
        name="address"
        [(ngModel)]="location"
        disabled
      />
    </mat-form-field>
  </div>
</div>
<div *ngIf="edit" fxLayout="row" fxLayoutAlign="space-between center">
  <div fxFlex="33">
    <mat-form-field appearance="outline">
      <mat-label>Latitud</mat-label>
      <input
        matInput
        type="text"
        name="location_lat"
        [(ngModel)]="latitude"
        disabled
      />
    </mat-form-field>
  </div>
  <div fxFlex="33">
    <mat-form-field appearance="outline">
      <mat-label>Longitud</mat-label>
      <input
        matInput
        type="text"
        name="location_lon"
        [(ngModel)]="longitude"
        disabled
      />
    </mat-form-field>
  </div>
  <div fxFlex="33">
    <mat-form-field appearance="outline">
      <mat-label>Porcentaje de area plantada (%)</mat-label>
      <input
        matInput
        type="text"
        title="Porcentaje de area plantada (%)"
        name="percentage_of_planted_area"
        [(ngModel)]="extra"
        disabled
      />
    </mat-form-field>
  </div>
</div>

<div id="location">
  <div *ngIf="title" style="padding: 0.5em; color: #8b2f00">
    <mat-icon *ngIf="icon">{{ icon }}</mat-icon
    ><span style="font-size: 2em"> {{ title }}</span>
  </div>
  <div
    id="map"
    leaflet
    [leafletOptions]="mapOptions"
    [style.height]="height_value"
    [leafletLayersControl]="layersControl"
    (leafletMapReady)="onMapReady($event)"
    (leafletClick)="onMapClick($event)"
  ></div>
</div>
